import { gql } from "@apollo/client";

export const AGREGAR_CIERRE_BOTON = gql`
mutation agregarCierreBoton($boton: Int!, $idPeriodo: Int!) {
    agregarCierreBoton(boton: $boton, idPeriodo: $idPeriodo) 
}`;